<template>
    <v-app>
        <Menu :authenticated="this.authenticated" v-if="this.showMenu()" />
        <Message ref="msg"></Message>
        <transition name="body">
            <router-view @authenticated="setAuthenticated"></router-view>
        </transition>
    </v-app>
</template>

<script>
import Message from "./components/shared/Message";
import Menu from "./components/shared/Menu";
import { routes } from "./routes";
import auth from "./helpers/auth";

export default {
    name: "App",
    components: {
        Menu,
        Message,
    },
    data() {
        return {
            routes,
            auth,
            timer: null,
            authenticated: false,
        };
    },
    mounted() {
        this.verify();
    },
    created() {
        this.timer = setInterval(this.verify, 1000);
    },
    methods: {
        showMenu() {
            this.routes.every((r) => {
                if (r.name == this.$router.currentRoute.name && !r.showMenu) {
                    return false;
                }
            });
            return true;
        },
        setAuthenticated(status) {
            this.authenticated = status;
        },
        verify() {
            if (!this.auth.isAuth()) {
                if (this.authenticated) {
                    this.authenticated = false;
                    this.$router.replace({ name: "home" });
                }
            } else {
                if (!this.authenticated) {
                    this.authenticated = true;
                    if (this.$router.currentRoute.name == "login") {
                        this.$router.replace({ name: "home" });
                    }
                }
            }

            if (!this.authenticated) {
                this.routes.every((r) => {
                    if (r.name == this.$router.currentRoute.name && r.login) {
                        /*console.log(
                            "******************* SECURITY BLOCK. Need login to access '" +
                                r.name +
                                "'"
                        );*/
                        this.$router.replace({ name: "home" });
                        return false;
                    }
                    return true;
                });
            }
        },
    },
    computed: {
        title() {
            var title = null;
            this.routes.every((r) => {
                if (r.name == this.$router.currentRoute.name && r.name != "home") {
                    title = r.title;
                    return false;
                }
                return true;
            });
            return title;
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>
